// extracted by mini-css-extract-plugin
module.exports = {"table":"CalculateGITabContentStyle-module--table--2ocPT","holder":"CalculateGITabContentStyle-module--holder--1i309"};